var obj = {
    init: function() {
        this.bind(1000);            // 所有绑定事件
        this.linkUrl();             // 相关跳转地址 
        this.wowAni();              // 滚动动画
    },
    initMobile: function() {
        this.bind(360);             // 所有绑定事件
        this.linkUrl();             // 相关跳转地址
        this.wowAni();              // 滚动动画
        this.isSwiper();            // 移动端swiper
    },
    bind: function(heightAni) {
        // 页面显示
        $('.index').addClass('index-show');

        var contentPage = document.getElementById("content-page");
        var contentTop = contentPage.offsetTop;
        if(location.hash !== '') {
            window.scrollTo({  top: contentTop + heightAni,  behavior: "smooth" });
            $(location.hash).addClass('select').siblings().removeClass('select').parent('.title-tab-box').siblings('.details-tab-box').children('.content-details').removeClass('show').eq($(this).index()).addClass('show');
        }

        $('.title-tab-box').on('click', 'a', function(event) {
            window.scrollTo({  top: contentTop + heightAni,  behavior: "smooth" });
            $(this).addClass('select').siblings().removeClass('select').parent('.title-tab-box').siblings('.details-tab-box').children('.content-details').removeClass('show');
            setTimeout(() => {
                $(this).addClass('select').siblings().removeClass('select').parent('.title-tab-box').siblings('.details-tab-box').children('.content-details').eq($(this).index()).addClass('show');
            }, 200);
        });

        $('.return-btn').click(function(event) {
            window.scrollTo({  top: contentTop + heightAni,  behavior: "smooth" });
            $(this).addClass('rocket-ani').fadeOut(1000);
            setTimeout(() => { $(this).removeClass('rocket-ani').fadeIn(); }, 1000);
        });
        
        // //滚动事件
        document.onscroll = function(){
            //获取当前滚动的距离
            var btop = document.body.scrollTop||document.documentElement.scrollTop;
            btop > 1200 ? $('.return-btn').addClass('return-btn-show') : $('.return-btn').removeClass('return-btn-show')
        }
    },
    linkUrl() {
        // 一.最新活动（视频方框）
        $('.video-btn').attr('href', 'https://www.youtube.com/watch?v=MeFz-K0-2P0');

        // 二.豪华记念活动（搞笑艺人 | 黄鹂鸟）
        $('.gxyr-btn').attr('href', 'https://twitter.com/supersnail_jp');
        $('.hln-btn').attr('href', 'https://snail.qcplay.co.jp/news-details.html?id=836');

        // 三.特别奖励活动（周年转推 | 猴子推特）
        $('.yznzt-btn').attr('href', 'https://twitter.com/supersnail_jp');
        $('.hztt-btn').attr('href', 'https://twitter.com/enjr0608');

        // 四.情报页面
        $('.app-btn').attr('href', 'https://apps.apple.com/jp/app/%E6%9C%80%E5%BC%B7%E3%81%A7%E3%82%93%E3%81%A7%E3%82%93/id1589608687');
        $('.google-btn').attr('href', 'https://play.google.com/store/apps/details?id=com.qcplay.snail.android.jp');
        $('.amazon-btn').attr('href', 'https://www.amazon.co.jp/gp/product/B0B9RHNP58/ref=s9_acss_bw_cg_appstore_1a1_w?pf_rd_m=A3P5ROKL5A1OLE&pf_rd_s=merchandised-search-top-1&pf_rd_r=KRKXK58MNJAZSC4TZZHP&pf_rd_t=101&pf_rd_p=ea1bfffc-8469-42f8-b5bc-fd7caaaade79&pf_rd_i=2386870051');

        // 五.公式sns底部的4个圆形icon跳转地址
        $('.tt-btn').attr('href', 'https://twitter.com/supersnail_jp');
        $('.luntan-btn').attr('href', 'https://discord.gg/supersnail-jp');
        $('.link-btn').attr('href', 'https://line.me/ti/g2/bYFFhLmMbYdtHekbQDx-gx7mtCWvsEpdFYt5ig?utm_source=invitation&utm_medium=link_copy&utm_campaign=default');
        $('.youtube-btn').attr('href', 'https://www.youtube.com/@user-gn4hx5rg3m');
    },
    isSwiper: function() {
        var swiper = new Swiper(".mySwiper", {
            effect: "cards",
            grabCursor: true,
            pagination: {
              el: ".swiper-pagination",
            }
        });
    },
    wowAni: function() {
        var wow = new WOW({ 
            boxClass: 'wow', 
            animateClass: 'animated', 
            offset: 0, 
            mobile: true, 
            live: true 
        }); 
        wow.init();
    }
}